import { render, staticRenderFns } from "./CashGeneral.vue?vue&type=template&id=04332b67&scoped=true&"
import script from "./CashGeneral.vue?vue&type=script&lang=js&"
export * from "./CashGeneral.vue?vue&type=script&lang=js&"
import style0 from "./CashGeneral.vue?vue&type=style&index=0&id=04332b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04332b67",
  null
  
)

export default component.exports